import classNames from "classnames";
import dayjs from "dayjs";
import { twMerge } from "tailwind-merge";

import { CheckIcon, TimerIcon, XCircle, XIcon } from "src/common/assets/icons";
import { useApprovalTimelineDrawer } from "src/zustand/approval-timeline-drawer";

import { CIconButton } from "../../controls";

//status: approved - rejected - current - pending

export const CApprovalTimelineDrawer = (props) => {
  //#region Data
  const {
    open,
    code,
    createdBy,
    createdDate,
    timelines,
    statusText,
    handleClose,
  } = useApprovalTimelineDrawer();
  //#endregion

  //#region Event
  //#endregion

  //#region Render
  return (
    <div
      className={classNames(
        "fixed inset-0 z-[200] h-screen w-screen bg-slate-900/40 backdrop-blur-sm [&_*]:!font-inter",
        open
          ? "opacity-100 pointer-events-auto"
          : "opacity-0 pointer-events-none",
      )}
      onClick={open ? handleClose : undefined}
    >
      <div
        className="fixed top-0 right-0 bottom-0 w-[440px] z-[200] flex flex-col bg-white shadow-lg"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <div className="p-[16px] border-b border-slate-200 flex items-center justify-between bg-slate-50">
          <div>
            <span className="text-sm font-semibold px-2 py-0.5 rounded bg-blue-100 text-blue-800">
              Chi tiết duyệt phiếu
            </span>
            <h3 className="font-semibold text-slate-700 text-base mt-1">
              {code}
            </h3>
          </div>
          <CIconButton
            onClick={handleClose}
            className="!text-slate-400"
            icon={<XCircle className="" />}
          />
        </div>

        <div className="p-[20px] overflow-y-auto flex-1 space-y-6">
          <div className="bg-slate-50 rounded-lg p-[14px] border border-slate-200 space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-slate-500">Người đề xuất:</span>{" "}
              <span className="font-medium text-slate-800">{createdBy}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-500">Ngày đề xuất:</span>{" "}
              <span className="font-medium text-slate-800">
                {dayjs(createdDate).format("HH:mm DD/MM/YYYY")}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-500">Trạng thái hiện tại:</span>{" "}
              <span
                className={twMerge(
                  "font-semibold text-slate-600",
                  statusText === "Hoàn thành" && "text-green-600",
                  statusText === "Từ chối" && "text-amber-600",
                )}
              >
                {statusText}
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-slate-800 text-sm uppercase tracking-wider mb-4 flex items-center gap-1.5">
              Tiến Trình Duyệt Chi Tiết
            </h4>

            <div className="relative pl-6 space-y-6 border-l-2 border-slate-200 ml-3">
              {timelines.map((item, index) => (
                <div className="relative" key={item.role_name + index}>
                  <div
                    className={twMerge(
                      "absolute -left-[38px] top-0 size-[26px] rounded-full text-white bg-slate-100",
                      "border-2 border-solid flex items-center justify-center",
                      "[&>svg]:size-4",
                      item.status === "approved" &&
                        "!bg-green-500 !border-green-600",
                      item.status === "rejected" &&
                        "!bg-amber-500 !border-amber-600",
                      item.is_overdue && "!bg-red-500 !border-red-600",
                    )}
                  >
                    {item.status === "current" ? (
                      <TimerIcon />
                    ) : item.status === "approved" ? (
                      <CheckIcon />
                    ) : item.status === "rejected" ? (
                      <XIcon />
                    ) : (
                      <span className="size-2 rounded-full bg-slate-400"></span>
                    )}
                  </div>
                  <div className="bg-slate-50 border border-slate-200 rounded-md p-[12px] space-y-1">
                    <div className="flex flex-row justify-between items-center">
                      <h5 className="text-sm font-semibold mb-0 text-slate-700">{`Bước ${index + 1}: ${item.role_name}`}</h5>
                      <span className="text-slate-500 text-xs font-medium">
                        {item.status === "current"
                          ? "Đang chờ duyệt"
                          : item.status === "pending"
                            ? ""
                            : dayjs(item.approved_date).format(
                                "HH:mm DD/MM/YYYY",
                              )}
                      </span>
                    </div>
                    <p className="text-sm text-slate-700">
                      Thời gian duyệt: {item.hours}h
                      {item.is_overdue && (
                        <span className="font-medium">
                          &nbsp;-&nbsp;Duyệt trễ
                        </span>
                      )}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="p-[16px] border-t border-slate-200 bg-slate-50 flex gap-2">
          <button
            onClick={handleClose}
            className="w-full py-2 bg-slate-200 hover:bg-slate-300 text-slate-700 font-semibold rounded-lg text-sm transition"
          >
            Đóng
          </button>
        </div>
      </div>
    </div>
  );
  //#endregion
};
